import * as classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import Icon, { IconType } from '../../atoms/Icon/Icon'
import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import ModalTemplate from '../../molecules/ModalTemplate/ModalTemplate'
import * as styles from './EditorImageUploadModal.css'

interface EditorImageUploadModalProps {
  isModalShow: boolean
  handleModal: () => void
  targetIndex: string
  imageUrl: string
  onChangeImage: (data: any) => void
  onDeleteImage: (data: any) => void
  errorMessage: null | string
}

const EditorImageUploadModal: React.FunctionComponent<EditorImageUploadModalProps> = ({
  isModalShow = false,
  handleModal,
  targetIndex,
  imageUrl,
  onChangeImage,
  onDeleteImage,
  errorMessage
}) => {
  const handleChangeImage = (e: any) => {
    const file = e.target.files[0]
    // 画像を選択し、アップロード後にもう一度画像選択画面を表示し、キャンセルボタンを押すとfileがundefinedになるため、その場合は何もしない
    if (!file) {
      return
    }

    onChangeImage({
      targetImage: file,
      targetKey: targetIndex
    })
  }

  return (
    <div className={classnames(styles.container, isModalShow ? styles.fadein : null)}>
      <ModalTemplate handleClick={() => handleModal()}>
        <div className={styles.modalContent} onClick={event => event.stopPropagation()}>
          <p className={styles.modalTitleText}>画像を編集</p>
          <div className={styles.labelContainer}>
            <div className={styles.thumbnailPart}>
              {imageUrl ? (
                <img className={styles.thumbnail} src={imageUrl} alt="upload image" />
              ) : (
                <div className={styles.thumbnail} />
              )}
            </div>
            <div className={styles.actionPart}>
              <label className={styles.buttonLabel}>
                <span>
                  <Icon iconType={IconType.IMAGE_UPLOAD_ICON} />
                  <p>アップロード</p>
                </span>
                <input hidden type="file" accept="image/png,image/jpg,image/bmp" onChange={handleChangeImage} />
              </label>
              <label
                className={styles.buttonLabel}
                onClick={() =>
                  onDeleteImage({
                    targetKey: targetIndex
                  })
                }
              >
                <span>
                  <Icon iconType={IconType.IMAGE_DELETE_ICON} />
                  <p>削除</p>
                </span>
              </label>
            </div>
          </div>
          {errorMessage ? (
            <div className={styles.modalErrorMessage}>
              <TextLabel size={SizeType.XTINY} weight={WeightType.LIGHT} color={ColorType.ERROR}>
                {errorMessage}
              </TextLabel>
            </div>
          ) : null}
        </div>
      </ModalTemplate>
    </div>
  )
}

export default compose<EditorImageUploadModalProps, EditorImageUploadModalProps>(pure)(EditorImageUploadModal)
